import CustomButton from "../../../../../../shared_components/CustomButton";
import img2 from "../../../../../../assets/images/AISummit/aicopilot3.jpg";

const RevisionHeroSection = () => {
    const statcards = [
        {
            id: 1,
            number: "500+",
            desc: "Students Joined"
        },
        {
            id: 2,
            number: "50+",
            desc: "Sessions Done"
        },
        {
            id: 3,
            number: "100%",
            desc: "Always Free"
        },
    ]
    return (
        <>
            <section className="row mx-0 mb-5 d-flex align-items-center justify-content-center my-5">
                <div className="col-12 col-md-10">
                    <div className="row mx-0 align-items-center">
                        <div className="col-12 col-md-6">
                            <h1 className="fw-bold mb-3 fs-md-48">Free Frontend Revision <br /> Classes</h1>
                            <h3>Every Week. No Cost. Real Learning.</h3>
                            <p className="mb-4">
                                Join me every weekend for live, interactive sessions where we revisit
                                frontend fundamentals, explore industry best practices, and master
                                the skills that actually matter. Completely free, forever.
                            </p>
                            <div className="d-flex">
                                <CustomButton className="px-3">Join Next Session</CustomButton>
                                <CustomButton className="ml-4 bg-light text-dark border-light px-3">
                                    View Schedule
                                </CustomButton>
                            </div>
                            <div className="row mx-0 d-flex align-items-start justify-content-start mt-4">
                                {statcards.map((item) => (
                                    <div className="col-4 col-md-4" key={item.id}>
                                        <div className="border radius-10 py-3 text-center h-100">
                                            <h4 className="fw-bold">{item.number}</h4>
                                            <p className="mb-0">{item.desc}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-12 col-md-6 text-center mt-3">
                            <img
                                src={img2}
                                alt="Revision Class"
                                className="img-fluid radius-10"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default RevisionHeroSection;